import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { env } from '../env';

// sessionStorage (CONTRACT section 10): the token dies with the tab, the right trade for an
// admin console that holds no refresh token (scope is `openid profile`, no offline_access).
export const userManager = new UserManager({
  authority: env.iamIssuer,
  client_id: env.iamClientId,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code', // PKCE S256 is oidc-client-ts's default for the code flow
  scope: 'openid profile',
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  // Silent renew needs a refresh token or an iframe; neither is configured, so expiry means sign in again.
  automaticSilentRenew: false,
});
